import SiteLayout from "@/components/feature/SiteLayout";
import Seo from "@/components/base/Seo";
import PageHero from "@/components/feature/PageHero";
import Reveal from "@/components/base/Reveal";
import ContactForm from "@/pages/contato/components/ContactForm";
import ContactChannels from "@/pages/contato/components/ContactChannels";
import BudgetForm from "@/pages/contato/components/BudgetForm";

export default function Contato() {
  return (
    <SiteLayout>
      <Seo
        title="Contato | Fale com um especialista da NXHOST"
        description="Fale com a NXHOST por WhatsApp, e-mail ou formulário. Tire as suas dúvidas sobre hospedagem, servidores, criação de sites e soluções digitais."
        keywords="contato NXHOST, falar com especialista, atendimento, WhatsApp NXHOST"
        path="/contato"
        titleEn="Contact | Talk to an NXHOST specialist"
        titleEs="Contacto | Habla con un especialista de NXHOST"
        descriptionEn="Contact NXHOST by WhatsApp, email or form. Get your questions answered about hosting, servers, website creation and digital solutions."
        descriptionEs="Contacta con NXHOST por WhatsApp, correo o formulario. Resuelve tus dudas sobre hosting, servidores, creación de sitios web y soluciones digitales."
        breadcrumbs={[
          { name: "Início", path: "/" },
          { name: "Contato", path: "/contato" },
        ]}
      />
      <PageHero
        badge="Fale com a NXHOST"
        badgeIcon="ri-customer-service-2-line"
        title="Vamos encontrar a estrutura ideal para o seu negócio."
        subtitle="Fale com a nossa equipe por WhatsApp, e-mail ou envie uma mensagem pelo formulário. Teremos prazer em ajudar você a escolher a melhor solução."
        crumbs={[{ label: "Início", to: "/" }, { label: "Contato" }]}
      />

      <section className="bg-background-50 py-16 md:py-24">
        <div className="mx-auto max-w-7xl px-4 md:px-8">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:gap-14">
            <div>
              <Reveal>
                <div className="mb-6">
                  <span className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-primary-700">
                    <i className="ri-contacts-book-2-line" aria-hidden="true"></i>
                    Canais de atendimento
                  </span>
                  <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
                    Escolha o melhor jeito de falar com a gente.
                  </h2>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                    Nossa equipe está pronta para entender o seu projeto e indicar a solução mais
                    adequada para o seu momento.
                  </p>
                </div>
              </Reveal>

              <ContactChannels />

              <Reveal delay={120}>
                <div className="mt-6 rounded-xl border border-background-200 bg-background-100/70 p-5">
                  <div className="flex items-center gap-3">
                    <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                      <i className="ri-mail-send-line text-xl" aria-hidden="true"></i>
                    </span>
                    <div>
                      <p className="font-heading text-sm font-semibold text-foreground-950">
                        E-mail comercial
                      </p>
                      <a
                        href="mailto:vendas@nxhost.com.br"
                        className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                      >
                        vendas@nxhost.com.br
                      </a>
                    </div>
                  </div>
                </div>
              </Reveal>
            </div>

            <Reveal delay={100}>
              <ContactForm />
            </Reveal>
          </div>
        </div>
      </section>

      <section id="orcamento" className="scroll-mt-24 bg-background-100 py-16 md:py-24">
        <div className="mx-auto max-w-5xl px-4 md:px-8">
          <Reveal>
            <BudgetForm />
          </Reveal>
        </div>
      </section>
    </SiteLayout>
  );
}